<template>
  <div>
    <v-container container--fluid grid-list-md>
      <v-row class="mt-2 ml-4">
        <h1 class="text-little">Key Manager</h1>
      </v-row>
    </v-container>

    <v-divider color="#42a5f5"></v-divider>

    <template>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="blue"
        grow
        slider-color="cyan accent-4"
      >
        <v-tab>
<!--          <v-icon>fas fa-user</v-icon>-->
          API Keys
        </v-tab>
        <v-tab>
<!--          <v-icon>fas fa-scroll</v-icon>-->
          Webhooks
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          :key="0"
        >
          <v-card flat>
            <ApiKeyManager
              :headers_props="apiKeyHeaders"
              :tableInfo="apiTableInfo"
              :keyItem_props="apiKeyItem"
            ></ApiKeyManager>
          </v-card>
        </v-tab-item>

        <v-tab-item
          :key="1"
        >
          <v-card flat>
            <ApiKeyManager
              :headers_props="webhookHeaders"
              :tableInfo="webhookTableInfo"
              :keyItem_props="webhookItem"
            ></ApiKeyManager>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

    </template>

  </div>
</template>

<script>
  import axios from 'axios'
  import ApiKeyManager from "./ApiKeyManager";

  export default {
      name: "ManageKeys",
      components: {ApiKeyManager},
    data() {
        return {
          tab: 0,
          apiTableInfo : {
            name: 'Api Key',
            apiUrl: (clientId) => {
              return '/clients/' + clientId + '/apikeys'
            }
          },
          apiKeyItem: {
            name: null,
            production: false,
            expires: null
          },

          webhookTableInfo : {
            name: 'Webhook',
            apiUrl: (clientId) => {
              return '/webhooks?client_id='+clientId
            }
          },
          webhookItem: {
            types: null,
            url: "https://",
            enabled: false
          },
        }
    },
    computed: {
      apiKeyHeaders(){
        let headers = [
          {text: 'Key id', value: 'id', align: 'center'},
          {text: 'Key name', value: 'name', align: 'center'},
          {text: 'Production', value: 'production', align: 'center'},
          {text: 'Creation date', value: 'created', align: 'center'},
          {text: 'Expiration date', value: 'expires', align: 'center'},
          {text: 'Created by', value: 'created_by', align: 'center'},
          {text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ];
        return headers;
      },
      webhookHeaders(){
        let headers = [
          {text: 'Key id', value: 'id', align: 'center'},
          {text: 'Type', value: 'types', align: 'center'},
          {text: 'Url', value: 'url', align: 'center'},
          {text: 'Creation date', value: 'created', align: 'center'},
          {text: 'Enabled', value: 'enabled', align: 'center'},
          {text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ];
        return headers;
      }
    }
  }
</script>

<style scoped>
  >>> .v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/ManageKeys/ManageKeys.vue